module.exports = __webpack_public_path__ + "img/asian-specialities-1.e5787bbe.jpg";